import { useContext } from "react";
import { HomePageContext } from "@/contexts/HomePageContext/HomePageContext";

export const useHomePageContext = () => {
  const context = useContext(HomePageContext);
  if (!context)
    throw new Error("Please use within bounds of Home Page Context Provider.");
  return context;
};
